import React from "react";

export default function MSAccess_LCase() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_LCase</h1>
      <p>This is the MSAccess_LCase component generated from the SQL JSON.</p>
    </div>
  );
}
